import { PropsWithChildren } from "react";
import style from "./DrawerContent.module.scss";

type DetailsRowProps = PropsWithChildren<{
  label: string;
}>;

const DetailsRow = ({ children, label }: DetailsRowProps) => {
  return (
    <div className={style.detailsRow}>
      <span className={style.label}>{label}</span>
      <span className={style.text}>{children}</span>
    </div>
  );
};

export default DetailsRow;
